<template>
  <div class="page">
    <div class="hearder">
      <div class="content clearfix">
        <p class="title fl">苏州市吴江区建协施工图设计技术审查中心</p>
        <div class="menu fr">
          <ul class="clearfix">
            <li :class="$route.path=='/'?'on':''" @click="goToPage('/')">首页</li>
            <li :class="$route.path=='/shencha'?'on':''" @click="goToPage('/shencha')">审查指南</li>
            <li :class="$route.path=='/all'?'on':''" @click="goToPage('/all')">设计依据</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="pic">
      <img src="../assets/bg.png" />
      <p>
        <a href="http://121.229.18.7:7000/" title="电子图报审" target="_blank"
          >数字化审图平台入口<span class="animate__animated animate__zoomIn animate__infinite">  &gt;&gt;</span></a
        ><br />
      </p>
    </div>
    <router-view></router-view>
    <div class="footer">
      <p>Copyright © 苏州市吴江区建协施工图设计技术审查中心 版权所有</p>
      <p>
        地址:江苏省苏州市吴江区太湖新城开平路450号君悦国际2幢11楼 |
        联系电话:0512-63460393
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
    }
  },
  mounted(){
    console.log('$router.path:',this.$route.path)
  },
  methods:{
    goToPage(path){
      this.$router.push({ path});
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  .hearder {
    .content {
      width: 1200px;
      margin: 0 auto;
      height: 100px;
      line-height: 100px;
      .title {
        padding-left: 100px;
        background: url(../assets/logo.png) no-repeat left center;
        background-size: 80px 80px;
        font-weight: 700;
        font-size: 36px;
      }
      .menu {
        li {
          width: 75px;
          text-align: center;
          float: left;
          font-size: 18px;
          font-weight: 500;
          margin-right: 10px;
          cursor: pointer;
          &.on {
            background: #2c88d3;
            color: #fff;
          }
        }
      }
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
  }
  .pic {
    position: relative;
    height: 168px;
    min-width: 1200px;
    p {
      position: absolute;
      top: 50%;
      left: 50%;
      font-size: 50px;
      color: #ffff;
      font-weight: 700;
      width: 1200px;
      transform: translate(-50%, -50%);
      margin: auto;
      a {
        color: #fff;
        text-decoration: none;
        span {
          font-size: 40px;
        }
      }
    }
  }
 
  .footer {
    background: #29323c;
    padding: 35px;
    text-align: center;
    font-size: 16px;
    color: #6c7f92;
    line-height: 36px;
    p {
      color: #fff;
    }
  }
}
</style>